// import React, { useEffect, useRef, useState } from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import { jwtDecode } from 'jwt-decode';
// import LoadingSkeleton from 'Components/LoadingSkeleton/MainSkeleton/LoadingSkeleton';

// const PublicRoute = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [isChecking, setIsChecking] = useState(true);
//   const location = useLocation();
//   const hasLoggedUrl = useRef(false);

//   useEffect(() => {
//     const checkAuth = async () => {
//       const token = localStorage.getItem('objectId');
      
//       if (!token) {
//         setIsAuthenticated(false);
//         setIsChecking(false);
//         return;
//       }

//       try {
//         const decodedToken = jwtDecode(token);
//         const currentTime = Date.now() / 1000;
        
//         // Check if token is valid and not expired
//         if (decodedToken.exp > currentTime) {
//           setIsAuthenticated(true);
//         } else {
//           // Token expired, clean it up
//           localStorage.removeItem('objectId');
//           setIsAuthenticated(false);
//         }
//       } catch (error) {
//         // Invalid token, clean it up
//         localStorage.removeItem('objectId');
//         setIsAuthenticated(false);
//       }
      
//       setIsChecking(false);
//     };

//     checkAuth();
//   }, []);

//   if (isChecking) {
//     return <div><LoadingSkeleton/></div>; // Replace with your loading component
//   }

//   // If authenticated, redirect to home page
//   if (isAuthenticated) {
//     // Get the previous path or default to home
//     const previousPath = localStorage.getItem('previousPath') || '/home';
//     localStorage.removeItem('previousPath'); // Clear it after use
//     return <Navigate to={previousPath} replace />;
//   }

//   // If not authenticated, render the public page
//   return <>{children}</>;
// };

// export default PublicRoute;

import React, { useEffect, useRef, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import LoadingSkeleton from 'Components/LoadingSkeleton/MainSkeleton/LoadingSkeleton';
import { useDispatch } from 'react-redux';
import { setDeeplinking } from '../../Redux/Reducers/OnboardingReducer';

const PublicRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const location = useLocation();
  const hasLoggedUrl = useRef(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const checkAuth = async () => {
      // Handle deeplinking - same logic as SessionHandler
      if (!hasLoggedUrl.current) {
        const params = new URLSearchParams(window.location.search);
        const backLinkUrl = params.get('back_link_url');
        const organizationId = params.get('organizationId');
       
        if (backLinkUrl) {
          dispatch(setDeeplinking(location.pathname + location.search));
        }
        else if(organizationId){
          dispatch(setDeeplinking(location.pathname + location.search));
        }
      
        hasLoggedUrl.current = true;
      }

      // Original authentication logic
      const token = localStorage.getItem('objectId');
      
      if (!token) {
        setIsAuthenticated(false);
        setIsChecking(false);
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        
        // Check if token is valid and not expired
        if (decodedToken.exp > currentTime) {
          setIsAuthenticated(true);
        } else {
          // Token expired, clean it up
          localStorage.removeItem('objectId');
          setIsAuthenticated(false);
        }
      } catch (error) {
        // Invalid token, clean it up
        localStorage.removeItem('objectId');
        setIsAuthenticated(false);
      }
      
      setIsChecking(false);
    };

    checkAuth();
  }, [dispatch, location.pathname, location.search]); // Added dependencies

  if (isChecking) {
    return <div><LoadingSkeleton/></div>;
  }

  // If authenticated, redirect to home page
  if (isAuthenticated) {
    // Get the previous path or default to home
    const previousPath = localStorage.getItem('previousPath') || '/home';
    localStorage.removeItem('previousPath'); // Clear it after use
    return <Navigate to={previousPath} replace />;
  }

  // If not authenticated, render the public page
  return <>{children}</>;
};

export default PublicRoute;